<template>
  <div>
    <div class="row step mt-1 mb-2" v-if="hasSteps">
      <div class="col">
        <strong class="step__intro mr-3">{{ $t('ContractStep.step.prefix') }}</strong>
        <span class="step__content">{{ lastStep.comment }}</span>
        <em class="step__date">{{ $t('ContractStep.step.date', { date: lastStepDate }) }}</em>
        <button class="btn btn-secondary btn-secondary-dark btn-sm ml-3" @click="showSteps">
          {{ $t('ContractStep.showSteps') }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button class="btn btn-secondary" role="button" @click="toggleForm">
          {{ $t('ContractStep.add') }}
        </button>
        <form class="form-inline ml-sm-2" action="#" v-if="showForm" @submit.prevent="onSubmit">
          <input type="text"
                 name="comment"
                 class="form-control"
                 v-model="comment"
                 :placeholder="$t('ContractStep.placeholder')">
          <button class="btn btn-icon" role="submit">
            <i class="fa fa-save"></i>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment-timezone';

import ContractStepsDialog from './ContractStepsDialog';
const DIALOG_NAME = 'ContractStepsDialog';

export default {
  name: 'ContractSteps',
  props: ['contract'],
  data() {
    return {
      showForm: false,
      comment: null
    }
  },
  mounted() {
    this.$dialog.registerComponent(DIALOG_NAME, ContractStepsDialog);
  },
  computed: {
    steps() {
      return this.contract.steps;
    },
    hasSteps() {
      return this.steps.length > 0;
    },
    lastStep() {
      let lastStepIndex = this.steps.length - 1;

      return this.steps[lastStepIndex];
    },
    lastStepDate() {
      return moment(this.lastStep.created_at).format(this.$i18n.t('format.date_at_time'))
    }
  },
  methods: {
    ...mapActions({
      addStep: 'contracts/addStep',
    }),
    onSubmit() {
      this.addStep({ contract: this.contract, comment: this.comment });
      this.toggleForm();
    },
    showSteps() {
      this.$dialog.alert(DIALOG_NAME, {
        view: DIALOG_NAME,
        html: true,
        animation: 'fade',
        steps: this.steps,
      });
    },
    toggleForm() {
      this.showForm = !this.showForm;
      if (!this.showForm) {
        this.comment = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/pages/_var.scss';

.step__intro {
  color: $color-master-dark;
}
.step__content, .step__date {
  color: $color-master-darkest;
}

form {
  margin-top: 8px;
  input.form-control {
    width: 350px;
  }
}

@media (min-width: 768px) {
  form {
    display: inline-block;
    margin-top: 0;
    input.form-control {
      width: 350px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractSteps.vue